// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__g69wV","label":"CategoryService_label__6kPzR","location":"CategoryService_location__2EfGS"};